import { BI_SCHEMA } from '../../../utils/bi-logger/bi-events';
import { initLogger } from '../../../utils/bi-logger/bi-logger';
import { BI_LOGGER_ACTION_NAMES } from '../../../utils/bi-logger/bi-logger.constants';

let biLogger;

export const createBiLogger = () =>
  (biLogger = initLogger({ schema: BI_SCHEMA }));

export const biLoggerMiddleware = () => (next) => (action) => {
  const { type, payload } = action;

  if (type === BI_LOGGER_ACTION_NAMES.EVENT) {
    biLogger = biLogger ? biLogger : createBiLogger();

    return biLogger
      .log(payload.event, { ...payload.params })
      .catch((reason) => {
        console.error('BI send error', reason);
        return Promise.reject(reason);
      });
  }

  return next(action);
};
